import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { burlingtonNjConfig } from "./data";

export default function BurlingtonNJPage() {
  return <CityPageTemplate config={burlingtonNjConfig} />;
}